export var STAGE;
(function (STAGE) {
    STAGE["EMAIL_VERIFICATION"] = "EMAIL_VERIFICATION";
    STAGE["COMPANY_INFORMATION"] = "COMPANY_INFORMATION";
    STAGE["PERSONAL_INFORMATION"] = "PERSONAL_INFORMATION";
    STAGE["REFERRAL_SCREEN"] = "REFERRAL_SCREEN";
    STAGE["PLAN_SELECTION"] = "PLAN_SELECTION";
    STAGE["IMPLEMENTATION_OPTIONS"] = "IMPLEMENTATION_OPTIONS";
    STAGE["EMBURSE_CARDS"] = "EMBURSE_CARDS";
    STAGE["RSM_PARTNER_REFERRAL_SCREEN"] = "RSM_PARTNER_REFERRAL_SCREEN";
    STAGE["BUSINESS_VERIFICATION"] = "BUSINESS_VERIFICATION";
    STAGE["SUBMIT_APPLICATION"] = "SUBMIT_APPLICATION";
    STAGE["PAYMENT_SUMMARY"] = "PAYMENT_SUMMARY";
    STAGE["FINISH"] = "FINISH";
})(STAGE || (STAGE = {}));
const _NEW_COMPANY_REQUIRED_STEPS = [
    {
        label: 'Company Information',
        content: ['Provide basic account information'],
        stages: [STAGE.COMPANY_INFORMATION],
        id: STAGE.COMPANY_INFORMATION
    },
    {
        label: 'Personal Information',
        content: ['Provide personal details'],
        stages: [STAGE.PERSONAL_INFORMATION],
        id: STAGE.PERSONAL_INFORMATION
    }
];
const _ADDITIONAL_COMPANY_REQUIRED_STEPS = _NEW_COMPANY_REQUIRED_STEPS.filter(({ id }) => id === STAGE.COMPANY_INFORMATION);
export function getAvailableStepsData(isFromSales, cards, skipReferralCards, isAdditionalCompany, isRsmPartner) {
    var _a;
    const isInternalBilling = window.FEATURES.stripe_billing || (!window.FEATURES.external_billing && !((_a = window.ORG) === null || _a === void 0 ? void 0 : _a.is_manual_billing_contract));
    const showPayment = !isRsmPartner && !isFromSales && isInternalBilling;
    const steps = !isAdditionalCompany ? [..._NEW_COMPANY_REQUIRED_STEPS] : [..._ADDITIONAL_COMPANY_REQUIRED_STEPS];
    let optionalSteps = {
        addCards: true,
        addPayment: showPayment,
        planSelection: true
    };
    if (isRsmPartner || isAdditionalCompany) {
        optionalSteps.planSelection = false;
    }
    if ((cards === 'hide' && !skipReferralCards) || isAdditionalCompany) {
        optionalSteps.addCards = false;
    }
    if (optionalSteps.planSelection) {
        steps.push({
            label: 'Plan Selection',
            content: ['Select your plan', 'Implement options'],
            stages: [STAGE.PLAN_SELECTION, STAGE.IMPLEMENTATION_OPTIONS],
            id: STAGE.PLAN_SELECTION
        });
    }
    if (optionalSteps.addCards) {
        steps.push({
            label: 'Emburse Cards',
            content: ['Apply for Cards', 'Business verification', 'Submit Application'],
            stages: [STAGE.EMBURSE_CARDS, STAGE.BUSINESS_VERIFICATION, STAGE.SUBMIT_APPLICATION],
            id: STAGE.EMBURSE_CARDS
        });
    }
    if (isRsmPartner) {
        steps.push({
            stages: [STAGE.RSM_PARTNER_REFERRAL_SCREEN],
            id: STAGE.RSM_PARTNER_REFERRAL_SCREEN
        });
    }
    if (optionalSteps.addPayment) {
        steps.push({
            label: 'Finish',
            content: ['Review and Pay', 'Start using Emburse Spend'],
            stages: [STAGE.PAYMENT_SUMMARY, STAGE.FINISH],
            id: STAGE.FINISH
        });
    }
    else {
        steps.push({
            label: 'Finish',
            content: ['Start using Emburse Spend'],
            stages: [STAGE.FINISH],
            id: STAGE.FINISH
        });
    }
    let stageToStepMapping = steps.reduce((acc, step, index) => {
        if (isFromSales && step.id === STAGE.PLAN_SELECTION) {
            return acc;
        }
        if (skipReferralCards && step.id === STAGE.EMBURSE_CARDS) {
            return acc;
        }
        const stages = step.stages;
        stages.forEach((stage) => {
            acc[stage] = index;
        });
        return acc;
    }, {});
    if (isFromSales) {
        let idToFind = STAGE.EMBURSE_CARDS;
        if (skipReferralCards) {
            idToFind = STAGE.FINISH;
        }
        const index = steps.findIndex((step) => step.id === idToFind);
        stageToStepMapping[STAGE.REFERRAL_SCREEN] = index;
    }
    return {
        steps,
        stageToStepMapping
    };
}
